import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { type OtSelectVariant } from '@1trading/design-system';
import { computed, type PropType } from 'vue';

import { authService } from '@exchange/libs/auth/service/src';
import { settingsService } from '@exchange/libs/settings/service/src';
import { langsInfoService, type LanguageListItem } from '@exchange/libs/utils/langs-info/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSetting',
  props: {
  toggle: { type: Boolean, default: false },
  variant: { type: String as PropType<OtSelectVariant>, default: 'dark-borderless' },
},
  emits: ["language-changed"],
  setup(__props, { emit: __emit }) {

const { language, languageList } = langsInfoService;


const emit = __emit;

const uniqueId = `language-select-${crypto.randomUUID()}`;

const chosenLanguage = computed(() => languageList.find((item) => item.id === language.value));

const setLanguageSetting = async (item: LanguageListItem) => {
  const languageCode = item.id;

  await langsInfoService.setLanguage(languageCode);
  emit('language-changed');

  if (authService.hasBeenAuthenticated) {
    await settingsService.setSettings({
      path: 'language',
      value: languageCode,
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_x_list_item = _resolveComponent("x-list-item")!
  const _component_ot_select = _resolveComponent("ot-select")!
  const _component_ot_button_dropdown = _resolveComponent("ot-button-dropdown")!

  return (!__props.toggle)
    ? (_openBlock(), _createBlock(_component_ot_select, {
        key: 0,
        value: chosenLanguage.value,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => ((chosenLanguage).value = $event)),
          setLanguageSetting
        ],
        class: "language-setting",
        label: "name",
        variant: __props.variant,
        options: _unref(languageList)
      }, {
        "selected-option": _withCtx(({ name }) => [
          _createVNode(_component_x_list_item, {
            class: "language-setting__selected",
            title: name,
            "left-icon-name": "global"
          }, null, 8, ["title"])
        ]),
        option: _withCtx(({ name, icon, id }) => [
          _createVNode(_component_x_list_item, {
            active: chosenLanguage.value && chosenLanguage.value.id === id,
            title: name,
            "left-icon-name": icon,
            "left-icon-variant": "flag"
          }, null, 8, ["active", "title", "left-icon-name"])
        ]),
        _: 1
      }, 8, ["value", "variant", "options"]))
    : (_openBlock(), _createBlock(_component_ot_button_dropdown, {
        key: 1,
        class: "language-setting language-setting--toggle",
        variant: "text",
        size: "sm",
        "unique-id": uniqueId,
        "btn-text": chosenLanguage.value?.id.toLocaleUpperCase()
      }, {
        options: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languageList), (item) => {
            return (_openBlock(), _createBlock(_component_x_list_item, {
              key: item.id,
              active: chosenLanguage.value && chosenLanguage.value.id === item.id,
              title: item.name,
              "left-icon-name": item.icon,
              "left-icon-variant": "flag",
              onClick: ($event: any) => (setLanguageSetting(item))
            }, null, 8, ["active", "title", "left-icon-name", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["btn-text"]))
}
}

})